export default __webpack_public_path__ + "static/blog-img1-37b11302328aa7c36e3516c4744d5692.png";